/* NOBLILUX Cart v1.3 — Drawer + Page + dataLayer + Shopify Analytics */
(function(){
'use strict';
var C=window.NobliluxCartConfig||{};
window.dataLayer=window.dataLayer||[];

function $(s,c){return(c||document).querySelector(s);}
function money(c){var n=(c/100).toFixed(2);return(C.moneyFormat||'{{amount}}').replace(/\{\{\s*amount\s*\}\}/,n).replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(c/100));}

/* Push event to GTM/GA4 dataLayer */
function dl(ev,cart){var items=(cart.items||[]).map(function(i){return{item_id:String(i.variant_id||''),item_name:i.product_title||'',item_variant:i.variant_title||'',price:parseFloat((i.price/100).toFixed(2)),currency:C.currency||'EUR',quantity:i.quantity||1};});window.dataLayer.push({ecommerce:null});window.dataLayer.push({event:ev,ecommerce:{currency:C.currency||'EUR',value:parseFloat((cart.total_price/100).toFixed(2)),items:items}});}

/* Publish event to Shopify native analytics */
function publishToShopify(eventName, item, cart) {
  try {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    if (eventName === 'product_added_to_cart' && item) {
      window.Shopify.analytics.publish('product_added_to_cart', {
        cartLine: {
          cost: {
            totalAmount: {
              amount: ((item.price * (item.quantity || 1)) / 100).toFixed(2),
              currencyCode: C.currency || 'GBP'
            }
          },
          merchandise: {
            id: 'gid://shopify/ProductVariant/' + (item.variant_id || item.id || ''),
            title: item.variant_title || '',
            product: {
              id: 'gid://shopify/Product/' + (item.product_id || ''),
              title: item.product_title || item.title || '',
              vendor: item.vendor || ''
            },
            price: {
              amount: (item.price / 100).toFixed(2),
              currencyCode: C.currency || 'GBP'
            }
          },
          quantity: item.quantity || 1
        }
      });
    } else if (eventName === 'checkout_started' && cart) {
      window.Shopify.analytics.publish('checkout_started', {
        checkout: {
          token: cart.token || '',
          totalPrice: {
            amount: (cart.total_price / 100).toFixed(2),
            currencyCode: C.currency || 'GBP'
          },
          lineItems: (cart.items || []).map(function(i) {
            return {
              quantity: i.quantity,
              title: i.product_title || '',
              variant: {
                id: 'gid://shopify/ProductVariant/' + i.variant_id,
                title: i.variant_title || '',
                price: { amount: (i.price / 100).toFixed(2), currencyCode: C.currency || 'GBP' }
              }
            };
          })
        }
      });
    }
  } catch(e) {}
}

var API={
  get:function(){return fetch('/cart.js').then(function(r){return r.json();});},
  change:function(key,qty){return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();});},
  add:function(id,qty){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:id,quantity:qty||1})}).then(function(r){return r.json();});}
};

function updateBar(el,total){
  if(!el||!C.freeShipping||!C.freeShipping.enabled)return;
  var t=C.freeShipping.threshold,rem=Math.max(0,t-total),pct=Math.min(100,Math.round(total/t*100));
  var m=el.querySelector('.nb-bar-msg'),f=el.querySelector('.nb-bar-fill');
  if(!m||!f)return;
  if(rem<=0){m.innerHTML=C.freeShipping.achieved;el.classList.add('is-done');}
  else{m.innerHTML=C.freeShipping.message.replace('{amount}',money(rem));el.classList.remove('is-done');}
  f.style.width=pct+'%';
}

var _upDone=false;
function loadUpsell(cart){
  var cfg=C.drawer&&C.drawer.upsell;
  if(!cfg||!cfg.enabled||!cfg.collection)return;
  var el=$('#nb-upsell'),list=$('#nb-upsell-list');
  if(!el||!list)return;
  if(_upDone){el.style.display='';return;}
  var ids=(cart.items||[]).map(function(i){return i.product_id;});
  fetch('/collections/'+cfg.collection+'/products.json?limit=8')
    .then(function(r){return r.json();})
    .then(function(d){
      var prods=(d.products||[]).filter(function(p){return ids.indexOf(p.id)===-1&&p.available;}).slice(0,cfg.count);
      if(!prods.length)return;
      list.innerHTML=prods.map(function(p){
        var v=p.variants[0];
        var img=p.featured_image?('<img class="nb-up-img" src="'+p.featured_image+'&width=120" alt="'+p.title+'" loading="lazy" width="56" height="56">'):'<div class="nb-up-img nb-up-noimg"></div>';
        return '<div class="nb-up-item">'+img+'<div class="nb-up-info"><p class="nb-up-title">'+p.title+'</p><p class="nb-up-price">'+money(v.price)+'</p></div><button class="nb-btn nb-btn--outline nb-btn--xs nb-up-add" type="button" data-vid="'+v.id+'" data-name="'+p.title.replace(/"/g,'&quot;')+'" data-price="'+v.price+'">+</button></div>';
      }).join('');
      el.style.display='';
      _upDone=true;
    }).catch(function(){});
}

function render(cart){
  var iEl=$('#nb-items'),eEl=$('#nb-empty'),fEl=$('#nb-footer'),cEl=$('.nb-count'),tEl=$('.nb-total');
  if(!iEl)return;
  var n=cart.item_count||0;
  if(cEl)cEl.textContent='('+n+')';
  if(n===0){iEl.innerHTML='';if(eEl)eEl.style.display='';if(fEl)fEl.style.display='none';var uEl=$('#nb-upsell');if(uEl)uEl.style.display='none';return;}
  if(eEl)eEl.style.display='none';
  if(fEl)fEl.style.display='';
  iEl.innerHTML=cart.items.map(function(item){
    var img=item.image?('<img class="nb-item-img" src="'+item.image.replace(/(\.[^.]+)$/,'_80x80$1')+'" alt="'+item.product_title+'" loading="lazy" width="76" height="76">'):('<div class="nb-item-img nb-item-noimg"></div>');
    var vt=item.variant_title&&item.variant_title!=='Default Title'?('<p class="nb-item-var">'+item.variant_title+'</p>'):''; 
    return '<div class="nb-item" data-key="'+item.key+'">'+
      '<div>'+img+'</div>'+
      '<div class="nb-item-body"><p class="nb-item-title">'+item.product_title+'</p>'+vt+
        '<div class="nb-item-row">'+
          '<div class="nb-qty"><button class="nb-qty-btn nb-minus" data-key="'+item.key+'" type="button" aria-label="Moins">&minus;</button><span class="nb-qty-val">'+item.quantity+'</span><button class="nb-qty-btn nb-plus" data-key="'+item.key+'" type="button" aria-label="Plus">+</button></div>'+
          '<span class="nb-item-price">'+money(item.line_price)+'</span>'+
        '</div>'+
      '</div>'+
      '<button class="nb-remove" data-key="'+item.key+'" type="button" aria-label="Supprimer">&times;</button>'+
    '</div>';
  }).join('');
  if(tEl)tEl.textContent=money(cart.total_price);
  updateBar($('#nb-bar'),cart.total_price);
  loadUpsell(cart);
  dl('view_cart',cart);
}

var drawer=$('#noblilux-drawer'),overlay=$('#noblilux-overlay'),_open=false;
function openDrawer(){
  if(!drawer)return;
  drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');
  if(overlay){overlay.classList.add('is-open');overlay.setAttribute('aria-hidden','false');}
  document.body.classList.add('nb-lock');
  _open=true;
  API.get().then(render);
}
function closeDrawer(){
  if(!drawer)return;
  drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');
  if(overlay){overlay.classList.remove('is-open');overlay.setAttribute('aria-hidden','true');}
  document.body.classList.remove('nb-lock');
  _open=false;
}
function qtyChange(key,d){
  var iEl=$('[data-key="'+key+'"] .nb-qty-val');
  if(!iEl)return;
  var nv=Math.max(0,(parseInt(iEl.textContent)||1)+d);
  iEl.textContent=nv;
  API.change(key,nv).then(function(c){_upDone=false;render(c);});
}

document.addEventListener('click',function(e){
  var t=e.target;
  if(!t)return;
  if(t.closest('.nb-close')||t.id==='noblilux-overlay'){closeDrawer();return;}
  var ca=t.closest('a[href="/cart"]');
  if(ca&&drawer){e.preventDefault();openDrawer();return;}
  var mi=t.closest('.nb-minus');if(mi){qtyChange(mi.dataset.key,-1);return;}
  var pl=t.closest('.nb-plus');if(pl){qtyChange(pl.dataset.key,1);return;}
  var rm=t.closest('.nb-remove');if(rm){API.change(rm.dataset.key,0).then(function(c){_upDone=false;render(c);});return;}
  var ua=t.closest('.nb-up-add');
  if(ua){
    var vid=parseInt(ua.dataset.vid);
    ua.disabled=true;
    ua.textContent='...';
    API.add(vid,1).then(function(){
      _upDone=false;
      return API.get();
    }).then(function(c){
      render(c);
      var upsellPrice=parseFloat(((parseInt(ua.dataset.price||0))/100).toFixed(2));
      window.dataLayer.push({ecommerce:null});
      window.dataLayer.push({event:'add_to_cart',ecommerce:{currency:C.currency||'EUR',value:upsellPrice,items:[{item_id:String(vid),item_name:ua.dataset.name||'',price:upsellPrice,currency:C.currency||'EUR',quantity:1}]}});
      /* Shopify native analytics — upsell add to cart */
      var _upsellItem={variant_id:vid,product_title:ua.dataset.name||'',variant_title:'',price:parseInt(ua.dataset.price||0),quantity:1,product_id:0};
      publishToShopify('product_added_to_cart', _upsellItem, null);
    });
    return;
  }
  if(t.closest('.nb-checkout')){
    API.get().then(function(c){
      dl('begin_checkout',c);
      /* Shopify native analytics — checkout started */
      publishToShopify('checkout_started', null, c);
    });
  }
},true);

document.addEventListener('keydown',function(e){if(e.key==='Escape'&&_open)closeDrawer();});

var _fetch=window.fetch;
window.fetch=function(url,opts){
  var u=typeof url==='string'?url:'';
  var isAdd=u.indexOf('/cart/add')!==-1&&opts&&opts.method&&opts.method.toUpperCase()==='POST';
  if(isAdd){
    return _fetch.apply(this,arguments).then(function(resp){
      if(resp.ok){
        resp.clone().json().then(function(data){
          var items=data.items||[data];
          var val=items.reduce(function(s,i){return s+(i.price||0)*(i.quantity||1)/100;},0);
          window.dataLayer.push({ecommerce:null});
          window.dataLayer.push({event:'add_to_cart',ecommerce:{currency:C.currency||'EUR',value:parseFloat(val.toFixed(2)),items:items.map(function(i){return{item_id:String(i.variant_id||i.id||''),item_name:i.product_title||i.title||'',item_variant:i.variant_title||'',price:parseFloat(((i.price||0)/100).toFixed(2)),currency:C.currency||'EUR',quantity:i.quantity||1};})}});
          /* Shopify native analytics — product added to cart */
          publishToShopify('product_added_to_cart', items[0], null);
          _upDone=false;
          if(window.location.pathname!=='/cart'){openDrawer();}
          else{window.location.reload();}
        }).catch(function(){});
      }
      return resp;
    });
  }
  return _fetch.apply(this,arguments);
};

window.NobliluxCart={open:openDrawer,close:closeDrawer,refresh:function(){API.get().then(render);}};
})();
